(function () {
  'use strict';

  // Scroll reveal + context-aware animation system
  function autoTag() {
    // auto-apply sensible animations to sections/images not explicitly tagged
    // (covers future Theme Editor sections without manual data-anim)
    if (!document.body.classList.contains('anim-scroll')) return;
    var map = [
      ['.philosophy .philosophy-image, .philosophy-media', 'fade-right'],
      ['.craft-step', 'fade-up'],
      ['.section-title, .vp-recs-heading, .heritage-title', 'fade-up'],
      ['.trust-item, .hero-stat', 'scale-in']
    ];
    map.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el) {
        if (!el.hasAttribute('data-anim') && !el.closest('[data-anim]')) el.setAttribute('data-anim', pair[1]);
      });
    });
    // stagger groups
    ['.fv3-grid', '.vp-recs-grid', '.trust-row, .fv3-trust-row', '.craft-steps', '.product-grid', '.collection-grid']
      .forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.hasAttribute('data-anim-stagger')) el.setAttribute('data-anim-stagger', '');
        });
      });
  }

  function revealEl(el) {
    el.classList.add('visible');
    el.classList.add('in');
  }

  function initReveal() {
    try {
      autoTag();
    } catch (e) {
      // never let a selector/autoTag issue block reveal below
    }
    var els = document.querySelectorAll('.reveal, [data-anim], [data-anim-stagger]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(revealEl);
      return;
    }

    try {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            window.requestAnimationFrame(function () { revealEl(el); });
            observer.unobserve(el);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { observer.observe(el); });
    } catch (e) {
      // observer failed to init for any reason — reveal everything now
      els.forEach(revealEl);
      return;
    }

    // Failsafe: whatever the reason (slow device, zero-height container,
    // observer edge case, app-script conflict), nothing stays invisible
    // forever. Force-reveal any stragglers shortly after load.
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.reveal:not(.visible), [data-anim]:not(.in), [data-anim-stagger]:not(.in)')
          .forEach(revealEl);
      }, 2000);
    });
  }

  // Mobile drawer
  function initDrawer() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        drawer.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initDrawer();
    });
  } else {
    initReveal();
    initDrawer();
  }
})();

// sticky header state
(function(){var nav=document.querySelector('.site-nav');if(!nav)return;var onScroll=function(){nav.classList.toggle('is-scrolled',window.scrollY>10)};window.addEventListener('scroll',onScroll,{passive:true});onScroll();})();

// ============================================================
// Announcement bar — carousel (autoplay, arrows, swipe)
// ============================================================
(function () {
  var bar = document.querySelector('[data-announce-bar]');
  if (!bar) return;

  var viewport = bar.querySelector('[data-announce-viewport]');
  var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announce-slide]'));
  if (!slides.length) return;

  var current = 0;
  var autoplay = bar.getAttribute('data-autoplay') === 'true';
  var speed = parseInt(bar.getAttribute('data-autoplay-speed'), 10) || 5000;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer = null;

  function activateLink(slide, active) {
    var link = slide.querySelector('.announce-link');
    if (!link) return;
    if (active) { link.removeAttribute('tabindex'); } else { link.setAttribute('tabindex', '-1'); }
  }

  function goTo(index) {
    var nextIndex = ((index % slides.length) + slides.length) % slides.length;
    if (nextIndex === current) return;
    var prevSlide = slides[current];
    var nextSlide = slides[nextIndex];
    prevSlide.classList.remove('is-active');
    prevSlide.setAttribute('aria-hidden', 'true');
    activateLink(prevSlide, false);
    nextSlide.classList.add('is-active');
    nextSlide.removeAttribute('aria-hidden');
    activateLink(nextSlide, true);
    current = nextIndex;
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function play() {
    if (!autoplay || reduceMotion || slides.length < 2) return;
    stop();
    timer = setInterval(next, speed);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  var prevBtn = bar.querySelector('[data-announce-prev]');
  var nextBtn = bar.querySelector('[data-announce-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); play(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); play(); });

  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', play);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', play);

  // Touch swipe
  if (viewport) {
    var startX = null;
    viewport.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var endX = (e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].clientX : startX;
      var delta = endX - startX;
      if (Math.abs(delta) > 40) { if (delta < 0) { next(); } else { prev(); } }
      startX = null;
      play();
    }, { passive: true });
  }

  play();

  // Non-sticky mode only: once the bar has scrolled past, the fixed header
  // closes the gap and sits flush at the top (purely a fixed-element offset
  // change — no reflow of page content, so this never contributes to CLS).
  if (!document.body.classList.contains('announce-sticky')) {
    var collapseAt = bar.offsetHeight || 44;
    var onAnnounceScroll = function () {
      document.body.classList.toggle('announce-collapsed', window.scrollY > collapseAt);
    };
    window.addEventListener('scroll', onAnnounceScroll, { passive: true });
    onAnnounceScroll();
  }
})();

// ============================================================
// Vidhate Paithani — AJAX Cart (card ATC, quick view, drawer)
// Vanilla JS, event-delegated, no dependencies.
// ============================================================
(function () {
  'use strict';

  var root = document.querySelector('[data-cart-drawer-root]');
  var drawer = root && root.querySelector('[data-cart-drawer]');
  var overlay = root && root.querySelector('.cart-drawer-overlay');
  var announce = root && root.querySelector('[data-cart-announce]');
  var currency = (root && root.dataset.currency) || 'INR';
  var lastFocus = null;
  var money = function (cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  // price + struck compare-at + auto "Save X%" pill (matches Liquid price-badge)
  var priceHtml = function (price, cmp) {
    if (cmp && cmp > price && price > 0) {
      var pct = Math.round(((cmp - price) * 100) / cmp);
      return '<s>' + money(cmp) + '</s> ' + money(price) +
        (pct > 0 ? ' <span class="price-badge">Save ' + pct + '%</span>' : '');
    }
    return money(price);
  };
  window.vpPriceHtml = priceHtml;
  var say = function (msg) { if (announce) { announce.textContent = ''; announce.textContent = msg; } };

  // ---------- cart count in header ----------
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      /* Empty cart, no badge — matching what header.liquid renders on
         load, so the first add makes it appear rather than making a 0
         turn into a 1. */
      el.hidden = Number(n) === 0;
      el.classList.remove('count-bump');
      void el.offsetWidth; // restart animation
      el.classList.add('count-bump');
    });
    var dc = root && root.querySelector('[data-drawer-count]');
    if (dc) dc.textContent = '(' + n + ')';
  }

  // ---------- drawer open/close ----------
  function openDrawer() {
    if (!drawer) return;
    xsellLoaded = false;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    root.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
    drawer.focus();
  }
  function closeDrawer() {
    if (!drawer || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-lock');
    window.setTimeout(function () { overlay.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeQuickView(); }
  });

  // ---------- free shipping bar ----------
  var FREE_SHIP = root ? parseInt(root.dataset.freeShip || '0', 10) : 0;
  function updateShipBar(cart) {
    var bar = root && root.querySelector('[data-ship-bar]');
    if (!bar) return;
    if (!FREE_SHIP || cart.item_count === 0) { bar.hidden = true; return; }
    bar.hidden = false;
    var msg = bar.querySelector('[data-ship-msg]');
    var fill = bar.querySelector('[data-ship-fill]');
    var total = cart.total_price;
    var pct = Math.min(100, Math.round((total / FREE_SHIP) * 100));
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (total >= FREE_SHIP) { msg.innerHTML = '\u2713 You\u2019ve unlocked <strong>Free Shipping</strong>'; bar.classList.add('is-complete'); }
      else { msg.innerHTML = 'Add <strong>' + money(FREE_SHIP - total) + '</strong> more for Free Shipping'; bar.classList.remove('is-complete'); }
    }
  }

  // ---------- free gift offer (e.g. free Paithani Potli on 20k+) ----------
  // The gift's ₹0 price comes from a Shopify Automatic Discount configured
  // in Admin; this only manages adding/removing the line item and the
  // progress messaging. A busy-flag prevents add/remove calls from
  // looping into each other when the cart refreshes.
  var GIFT_ON = !!(root && root.dataset.giftEnable === '1');
  var GIFT_THRESHOLD = root ? parseInt(root.dataset.giftThreshold || '0', 10) : 0;
  var GIFT_VARIANT = root ? String(root.dataset.giftVariantId || '') : '';
  var GIFT_IMAGE = root ? String(root.dataset.giftImage || '') : '';
  var GIFT_PROGRESS_LABEL = (root && root.dataset.giftProgressLabel) || 'Add [[amount]] more for a FREE gift';
  var GIFT_UNLOCKED_LABEL = (root && root.dataset.giftUnlockedLabel) || 'You\u2019ve unlocked a FREE gift!';
  var giftBusy = false;
  // Collection free gift (vp-collection-gift.js): drawer treats it as a gift line too
  var CG_VARIANT = root ? String(root.dataset.cgVariantId || '') : '';
  var CG_TAG = (root && root.dataset.cgLabel) || 'Free Gift';

  function giftLine(cart) {
    if (!GIFT_VARIANT) return null;
    var found = null;
    cart.items.forEach(function (it) { if (String(it.variant_id) === GIFT_VARIANT) found = it; });
    return found;
  }

  function updateGiftBars(cart) {
    var bars = document.querySelectorAll('[data-gift-bar]');
    if (!bars.length) return;
    var hasGift = !!giftLine(cart);
    // Compare against the cart total minus the gift's own (already
    // discounted) price, so the bar reflects genuine purchase value.
    var giftLn = giftLine(cart);
    var total = cart.total_price - (giftLn ? giftLn.final_line_price : 0);
    bars.forEach(function (bar) {
      if (!GIFT_ON || cart.item_count === 0) { bar.hidden = true; return; }
      bar.hidden = false;
      var msg = bar.querySelector('[data-gift-msg]');
      var fill = bar.querySelector('[data-gift-fill]');
      var pct = GIFT_THRESHOLD ? Math.min(100, Math.round((total / GIFT_THRESHOLD) * 100)) : 0;
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (total >= GIFT_THRESHOLD) { msg.innerHTML = GIFT_UNLOCKED_LABEL; bar.classList.add('is-complete'); }
        else {
          var remaining = money(GIFT_THRESHOLD - total);
          msg.innerHTML = GIFT_PROGRESS_LABEL.replace('[[amount]]', '<strong>' + remaining + '</strong>');
          bar.classList.remove('is-complete');
        }
      }
    });
    return { hasGift: hasGift, qualifies: total >= GIFT_THRESHOLD };
  }

  function syncGiftItem(cart) {
    if (!GIFT_ON || !GIFT_VARIANT || giftBusy) return;
    var status = updateGiftBars(cart);
    if (!status) return;
    if (status.qualifies === status.hasGift) {
      try { sessionStorage.removeItem('vp_gift_reload'); } catch (e) {}
      return;
    }
    var onCartPage = !!document.querySelector('.cart-page');
    function afterChange(res) {
      giftBusy = false;
      if (res && !res.ok) {
        res.json().then(function (err) {
          console.warn('[free gift] cart update failed:', (err && err.description) || err);
        }).catch(function () {});
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          renderDrawer(c);
          if (onCartPage && res && res.ok) safeGiftReload();
        })
        .catch(function () {});
    }
    if (status.qualifies && !status.hasGift && cart.item_count > 0) {
      giftBusy = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(GIFT_VARIANT), quantity: 1, properties: { '_free_gift': 'true' } }] })
      }).then(afterChange).catch(function () { giftBusy = false; });
    } else if (!status.qualifies && status.hasGift) {
      var line = giftLine(cart);
      if (!line) return;
      giftBusy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      }).then(afterChange).catch(function () { giftBusy = false; });
    }
  }
  /* Reload guard so a full /cart page picks up the gift line without
     ever looping — same pattern used for the finishing-services cleanup. */
  function safeGiftReload() {
    var n = 0;
    try { n = parseInt(sessionStorage.getItem('vp_gift_reload') || '0', 10); } catch (e) {}
    if (n >= 2) return;
    try { sessionStorage.setItem('vp_gift_reload', String(n + 1)); } catch (e) {}
    window.location.reload();
  }

  // ---------- savings summary ----------
  function updateSavings(cart) {
    var box = root && root.querySelector('[data-drawer-savings]');
    if (!box) return;
    var saved = 0;
    cart.items.forEach(function (it) {
      if (it.original_line_price && it.line_price && it.original_line_price > it.line_price) {
        saved += it.original_line_price - it.line_price;
      }
    });
    if (saved > 0) { box.hidden = false; box.querySelector('[data-savings-amount]').textContent = '\u2212 ' + money(saved); }
    else box.hidden = true;
  }

  // ---------- cross-sell / FBT ----------
  var xsellLoaded = false;
  function loadXsell(cart) {
    if (!root || root.dataset.xsell !== '1') return;
    var wrap = root.querySelector('[data-cart-xsell]');
    var host = root.querySelector('[data-xsell-items]');
    if (!wrap || !host || xsellLoaded || !cart.items.length) return;
    xsellLoaded = true;
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=complementary', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
        var recs = (data.products || []).filter(function (p) {
          var tags = p.tags || [];
          return !inCart[p.id] && p.available && tags.indexOf('addon-service') === -1;
        }).slice(0, 3);
        if (!recs.length) { wrap.hidden = true; return; }
        wrap.hidden = false;
        host.innerHTML = recs.map(function (p) {
          var v = p.variants && p.variants[0];
          var img = p.featured_image ? esc(p.featured_image).replace(/(\.[a-z]{3,4})(\?|$)/, '_120x$1$2') : '';
          var cmp = (v && v.compare_at_price && v.compare_at_price > v.price) ? '<s>' + money(v.compare_at_price) + '</s> ' : '';
          return '<div class="xsell-item">' +
            '<a href="' + esc(p.url) + '" class="xsell-media">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" width="52" height="66" loading="lazy">' : '') + '</a>' +
            '<div class="xsell-info"><a href="' + esc(p.url) + '" class="xsell-title">' + esc(p.title) + '</a>' +
            '<div class="xsell-price">' + cmp + money(v ? v.price : p.price) + '</div></div>' +
            '<button type="button" class="xsell-add" data-atc data-variant-id="' + (v ? v.id : '') + '" data-product-title="' + esc(p.title) + '" aria-label="Add ' + esc(p.title) + '">+</button>' +
          '</div>';
        }).join('');
      })
      .catch(function () { wrap.hidden = true; });
  }

  // ---------- add-on services offer in drawer ----------
  // Visible only when the cart holds at least one normal product;
  // each service row hides once that service is already in the cart.
  function updateCartAddons(cart) {
    var box = root && root.querySelector('[data-cart-addons]');
    if (!box) return;
    var rows = [].slice.call(box.querySelectorAll('[data-cart-addon-row]'));
    if (!rows.length || cart.item_count === 0) { box.hidden = true; return; }
    var addonIds = rows.map(function (r) { return String(r.dataset.variantId); });
    var inCart = {};
    var hasMain = false;
    cart.items.forEach(function (it) {
      var vid = String(it.variant_id);
      inCart[vid] = 1;
      if (addonIds.indexOf(vid) === -1) hasMain = true;
    });
    var visible = 0;
    rows.forEach(function (r) {
      var show = hasMain && !inCart[String(r.dataset.variantId)];
      r.hidden = !show;
      if (show) visible++;
    });
    box.hidden = visible === 0;
  }

  // ---------- drawer rendering from /cart.js ----------
  function renderDrawer(cart) {
    if (!root) return;
    // Only ever draw from a real cart payload. An error body has no
    // items array, and drawing half of it left the drawer in a state
    // that did not match the cart.
    if (!cart || typeof cart.item_count !== 'number' || !cart.items) return;
    setCount(cart.item_count);
    if (cart.item_count > 0) {
      document.querySelectorAll('[data-empty-cart-head]').forEach(function (el) { el.hidden = true; });
    }
    var items = root.querySelector('[data-drawer-items]');
    var empty = root.querySelector('[data-drawer-empty]');
    var foot = root.querySelector('[data-drawer-foot]');
    var subtotal = root.querySelector('[data-drawer-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (empty) empty.hidden = cart.item_count > 0;
    if (foot) foot.hidden = cart.item_count === 0;
    updateShipBar(cart);
    updateSavings(cart);
    updateCartAddons(cart);
    updateGiftBars(cart);
    syncGiftItem(cart);
    if (cart.item_count === 0) { var xs = root.querySelector('[data-cart-xsell]'); if (xs) xs.hidden = true; }
    else { loadXsell(cart); }
    if (!items) return;
    items.innerHTML = cart.items.map(function (it) {
      var isCg = CG_VARIANT !== '' && String(it.variant_id) === CG_VARIANT;
      var isGift = (GIFT_ON && GIFT_VARIANT && String(it.variant_id) === GIFT_VARIANT) || isCg;
      var imgSrc = (isGift && GIFT_IMAGE)
        ? esc(GIFT_IMAGE)
        : (it.image ? esc(it.image).replace(/(\.[a-z]{3,4})(\?|$)/, '_120x$1$2') : '');
      var img = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + esc(it.product_title) + '" width="60" height="80" loading="lazy">'
        : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title'
        ? '<div class="drawer-item-variant">' + esc(it.variant_title) + '</div>' : '';
      var isVm = !!(it.properties && it.properties._vm_gift);
      var giftTag = (isGift || isVm) ? '<span class="drawer-gift-tag">' + esc(isCg ? CG_TAG : 'Free Gift') + '</span>' : '';
      var qtyBlock = (isGift || isVm) ? '' :
            '<div class="drawer-qty" data-qty>' +
              '<button type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
              '<span data-qty-value>' + it.quantity + '</span>' +
              '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
            '</div>';
      return '<div class="drawer-item' + ((isGift || isVm) ? ' drawer-item--gift' : '') + (isCg ? ' drawer-item--cg' : '') + '" data-line-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '" class="drawer-item-media">' + img + '</a>' +
        '<div class="drawer-item-info">' +
          '<div class="drawer-item-title">' + esc(it.product_title) + giftTag + '</div>' + variant +
          '<div class="drawer-item-row">' +
            qtyBlock +
            '<span class="drawer-item-price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="drawer-item-remove" data-line-remove aria-label="Remove ' + esc(it.product_title) + '">Remove</button>' +
      '</div>';
    }).join('');
  }

  window.vpRefreshCart = function () { return refreshCart(); };
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); return cart; });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      // Shopify answers 422 when the line cannot go that high - one saree
      // in stock, two asked for. The response body is then an error
      // object with no items and no item_count, and feeding that to
      // renderDrawer left the drawer showing a quantity the cart never
      // accepted. Re-read the real cart instead, and say why.
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (e) {
          return refreshCart().then(function () {
            say((e && e.description) ? e.description : 'That is all we have of this one');
          });
        });
      }
      return r.json().then(function (cart) { renderDrawer(cart); });
    });
  }

  // ---------- add to cart ----------
  function addVariant(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function buttonState(btn, state) {
    btn.classList.remove('is-loading', 'is-done', 'is-error');
    btn.disabled = state === 'loading';
    btn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    if (state === 'loading') btn.classList.add('is-loading');
    if (state === 'done') btn.classList.add('is-done');
    if (state === 'error') btn.classList.add('is-error');
  }

  function handleAdd(btn, variantId, qty, title) {
    buttonState(btn, 'loading');
    addVariant(variantId, qty).then(function () {
      return refreshCart();
    }).then(function () {
      buttonState(btn, 'done');
      say((title || 'Item') + ' added to cart');
      window.setTimeout(function () { openDrawer(); }, 350);
      window.setTimeout(function () { buttonState(btn, ''); }, 2200);
    }).catch(function (err) {
      buttonState(btn, 'error');
      var label = btn.querySelector('.card-atc-label');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = (err && err.description) ? 'Unavailable' : 'Try Again';
      say('Could not add to cart');
      window.setTimeout(function () {
        buttonState(btn, '');
        if (label) label.textContent = prev || 'Add to Cart';
      }, 2600);
    });
  }

  // ---------- quick view (multi-variant) ----------
  var qv = null;
  function closeQuickView() {
    if (!qv) return;
    var el = qv; qv = null;
    el.classList.remove('is-open');
    document.body.classList.remove('drawer-lock');
    window.setTimeout(function () { el.remove(); }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openQuickView(handle, url, opener) {
    lastFocus = opener;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var optionsHtml = p.options.map(function (opt, i) {
          // Shopify's /products/<handle>.js returns options as objects
          // ({name, position, values}) on current API versions and as plain
          // strings on older ones. Printing the object gives "[object Object]".
          var name = (opt && typeof opt === 'object') ? opt.name : opt;
          var values = [];
          p.variants.forEach(function (v) {
            var val = v['option' + (i + 1)];
            if (val && values.indexOf(val) === -1) values.push(val);
          });
          // A product with no real options still carries one Shopify calls
          // "Title", holding the single value "Default Title". A dropdown with
          // one meaningless choice helps nobody, so it is left out.
          if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return '';
          return '<label class="qv-field"><span>' + esc(name) + '</span>' +
            '<select data-qv-option="' + i + '">' +
            values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('') +
            '</select></label>';
        }).join('');

        var wrap = document.createElement('div');
        wrap.className = 'qv-root';
        wrap.innerHTML =
          '<div class="qv-overlay" data-qv-close></div>' +
          '<div class="qv-modal" role="dialog" aria-modal="true" aria-label="' + esc(p.title) + ' options" tabindex="-1">' +
            '<button type="button" class="qv-close" data-qv-close aria-label="Close">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
            (p.featured_image ? '<img class="qv-img" src="' + esc(p.featured_image).replace(/(\.[a-z]{3,4})(\?|$)/, '_400x$1$2') + '" alt="">' : '') +
            '<div class="qv-body">' +
              '<h3 class="qv-title">' + esc(p.title) + '</h3>' +
              '<div class="qv-price" data-qv-price>' + priceHtml(p.price, p.compare_at_price) + '</div>' +
              optionsHtml +
              '<label class="qv-field"><span>Quantity</span><input type="number" value="1" min="1" data-qv-qty></label>' +
              '<button type="button" class="card-atc qv-atc" data-qv-add>' +
                '<span class="card-atc-label">Add to Cart</span>' +
                '<span class="card-atc-spinner" aria-hidden="true"></span>' +
                '<span class="card-atc-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="15" height="15"><path d="M4 12.5l5 5L20 6.5"/></svg></span>' +
              '</button>' +
              '<a class="qv-full-link" href="' + esc(url) + '">View full details</a>' +
            '</div>' +
          '</div>';
        document.body.appendChild(wrap);
        document.body.classList.add('drawer-lock');
        qv = wrap;
        window.requestAnimationFrame(function () { wrap.classList.add('is-open'); });
        var modal = wrap.querySelector('.qv-modal');
        modal.focus();

        function currentVariant() {
          var sel = [].map.call(wrap.querySelectorAll('[data-qv-option]'), function (s) { return s.value; });
          return p.variants.find(function (v) {
            return sel.every(function (val, i) { return v['option' + (i + 1)] === val; });
          });
        }
        function syncState() {
          var v = currentVariant();
          var btn = wrap.querySelector('[data-qv-add]');
          var price = wrap.querySelector('[data-qv-price]');
          var label = btn.querySelector('.card-atc-label');
          if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; return; }
          price.innerHTML = priceHtml(v.price, v.compare_at_price);
          btn.disabled = !v.available;
          label.textContent = v.available ? 'Add to Cart' : 'Sold Out';
          btn.dataset.variantId = v.id;
          applyMax();
        }
        // One-off sarees: the quantity box stops at what is in stock.
        var stock = {};
        function applyMax() {
          var v = currentVariant();
          var q = wrap.querySelector('[data-qv-qty]');
          var m = v ? Number(stock[v.id]) : 0;
          if (!q) return;
          if (m > 0) { q.max = m; if (Number(q.value) > m) q.value = m; }
          else q.removeAttribute('max');
        }
        fetch('/products/' + encodeURIComponent(handle) + '?sections=qv-stock', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var m = /QV_STOCK:(\{.*?\}):END/.exec(String(j['qv-stock'] || ''));
            if (m) { stock = JSON.parse(m[1]); applyMax(); }
          }).catch(function () {});
        wrap.addEventListener('input', function (e) {
          if (e.target.matches('[data-qv-qty]')) applyMax();
        });
        wrap.addEventListener('change', function (e) {
          if (e.target.matches('[data-qv-option]')) syncState();
          if (e.target.matches('[data-qv-qty]')) applyMax();
        });
        syncState();
      })
      .catch(function () { say('Could not load product options'); });
  }

  // ---------- delegated events ----------
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-atc]'))) {
      e.preventDefault();
      handleAdd(t, t.dataset.variantId, 1, t.dataset.productTitle);
      return;
    }
    if ((t = e.target.closest('[data-quick-view]'))) {
      e.preventDefault();
      openQuickView(t.dataset.handle, t.dataset.url, t);
      return;
    }
    if ((t = e.target.closest('[data-qv-add]'))) {
      e.preventDefault();
      var qtyEl = qv && qv.querySelector('[data-qv-qty]');
      var q = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      buttonState(t, 'loading');
      addVariant(t.dataset.variantId, q).then(refreshCart).then(function () {
        buttonState(t, 'done');
        say('Added to cart');
        window.setTimeout(function () { closeQuickView(); openDrawer(); }, 500);
      }).catch(function () {
        buttonState(t, 'error');
        say('Could not add to cart');
        window.setTimeout(function () { buttonState(t, ''); }, 2000);
      });
      return;
    }
    if (e.target.closest('[data-qv-close]')) { closeQuickView(); return; }

    if ((t = e.target.closest('.js-cart-toggle'))) {
      e.preventDefault();
      refreshCart().then(openDrawer);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    if ((t = e.target.closest('[data-qty-plus], [data-qty-minus], [data-line-remove]'))) {
      var line = t.closest('[data-line-key]');
      if (!line) return;
      var key = line.dataset.lineKey;
      if (t.hasAttribute('data-line-remove')) { changeLine(key, 0); return; }
      var valEl = line.querySelector('[data-qty-value]');
      var cur = parseInt(valEl.textContent, 10) || 1;
      changeLine(key, t.hasAttribute('data-qty-plus') ? cur + 1 : Math.max(0, cur - 1));
    }
  });

  // Keep the free-gift offer in sync on every page load (product pages,
  // full /cart page, etc.) — not just when the drawer itself is opened.
  if (GIFT_ON && GIFT_VARIANT) { refreshCart(); }
})();

// ============================================================
// Mega menu (hover intent + keyboard) & mobile accordion
// ============================================================
(function () {
  'use strict';

  // ---------- desktop mega menu ----------
  var items = document.querySelectorAll('[data-mega-item]');
  var closeTimer = null;

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var toggle = item.querySelector('[data-mega-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) {
    items.forEach(function (it) { if (it !== except) setOpen(it, false); });
  }

  items.forEach(function (item) {
    var toggle = item.querySelector('[data-mega-toggle]');

    // hover intent
    item.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      closeAll(item);
      setOpen(item, true);
    });
    item.addEventListener('mouseleave', function () {
      closeTimer = window.setTimeout(function () { setOpen(item, false); }, 180);
    });

    // keyboard: ArrowDown/Space opens, Enter follows the link naturally
    if (toggle) {
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          closeAll(item);
          setOpen(item, true);
          var first = item.querySelector('.mega-panel a');
          if (first) first.focus();
        }
      });
    }

    // keep open while focus is inside; close when it leaves
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) setOpen(item, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mega-item]')) closeAll(null);
  });

  // ---------- mobile accordion ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acc-toggle]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('[data-acc]');
    var open = !item.classList.contains('is-open');
    // close siblings at the same level
    var parent = item.parentElement;
    [].forEach.call(parent.children, function (sib) {
      if (sib !== item && sib.classList && sib.classList.contains('is-open')) {
        sib.classList.remove('is-open');
        var t = sib.querySelector('[data-acc-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

// ============================================================
// Product gallery: thumbnail swap, hover zoom, lightbox,
// mobile swipe sync, pinch & double-tap zoom.
// ============================================================
(function () {
  'use strict';
  var g = document.querySelector('[data-gallery]');
  if (!g) return;

  var stage = g.querySelector('[data-pg-stage]');
  var slides = [].slice.call(g.querySelectorAll('[data-pg-slide]'));
  var thumbs = [].slice.call(g.querySelectorAll('[data-pg-thumb]'));
  var dots = [].slice.call(g.querySelectorAll('.pg-dot'));
  var zoomOn = g.dataset.zoom === 'true';
  var lightboxOn = g.dataset.lightbox === 'true';
  var current = 0;
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function setActive(i, scroll) {
    if (i < 0) i = slides.length - 1;
    if (i >= slides.length) i = 0;
    current = i;
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    thumbs.forEach(function (t, idx) {
      t.classList.toggle('is-active', idx === i);
      t.setAttribute('aria-selected', idx === i ? 'true' : 'false');
    });
    dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    if (scroll && isMobile()) {
      slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { setActive(Number(t.dataset.index), true); });
  });

  // mobile swipe -> sync dots/thumbs
  var scrollT = null;
  stage.addEventListener('scroll', function () {
    if (!isMobile()) return;
    window.clearTimeout(scrollT);
    scrollT = window.setTimeout(function () {
      var i = Math.round(stage.scrollLeft / stage.clientWidth);
      if (i !== current) setActive(i, false);
    }, 80);
  }, { passive: true });

  // ---------- hover zoom (desktop) ----------
  if (zoomOn) {
    stage.setAttribute('data-zoomable', '');
    var hiresDone = {};
    stage.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      var slide = slides[current];
      if (slide && !hiresDone[current] && slide.dataset.full) {
        var img = slide.querySelector('img');
        var pre = new Image();
        pre.onload = function () { img.src = slide.dataset.full; };
        pre.src = slide.dataset.full;
        hiresDone[current] = true;
      }
      stage.classList.add('is-zooming');
    });
    stage.addEventListener('mousemove', function (e) {
      if (isMobile() || !stage.classList.contains('is-zooming')) return;
      var img = slides[current] && slides[current].querySelector('img');
      if (!img) return;
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2)';
    });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zooming');
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
      });
    });
  }

  // ---------- lightbox ----------
  if (!lightboxOn) return;
  var lb = null;

  function lbSrc(i) {
    var s = slides[i];
    return (s && s.dataset.full) || (s && s.querySelector('img') && s.querySelector('img').src) || '';
  }

  function openLb(startIndex) {
    if (slides[startIndex] && slides[startIndex].dataset.mediaType === 'video') return;

    /* Never build a second one. `lb` is a single shared reference, so a
       second lightbox would overwrite it and leave the first orphaned in
       the DOM with nothing pointing at it — a position:fixed, inset:0,
       z-index:300 box that close() can no longer reach. .pg-lb has no
       pointer-events:none, so an orphan swallows every touch on the page
       whether or not it is visible. That is the scroll-lock. */
    if (lb) return;
    var idx = startIndex;
    var scale = 1, tx = 0, ty = 0;
    var lastFocus = document.activeElement;

    lb = document.createElement('div');
    lb.className = 'pg-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image gallery');
    lb.innerHTML =
      '<button type="button" class="pg-lb-close" aria-label="Close gallery"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      (slides.length > 1 ? '<button type="button" class="pg-lb-nav pg-lb-prev" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' : '') +
      '<div class="pg-lb-img-wrap"><img alt="Product image"></div>' +
      (slides.length > 1 ? '<button type="button" class="pg-lb-nav pg-lb-next" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' : '') +
      '<div class="pg-lb-count" aria-hidden="true"></div>'
    ;
    document.body.appendChild(lb);
    document.body.classList.add('drawer-lock');

    var wrap = lb.querySelector('.pg-lb-img-wrap');
    var img = wrap.querySelector('img');
    var count = lb.querySelector('.pg-lb-count');

    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      wrap.classList.toggle('is-zoomed', scale > 1.02);
    }
    function resetZoom() { scale = 1; tx = 0; ty = 0; apply(); }
    function show(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      idx = i;
      img.src = lbSrc(i);
      count.textContent = (i + 1) + ' / ' + slides.length;
      resetZoom();
    }
    function close() {
      /* close() can now arrive twice — a backdrop click followed by Esc,
         or the close button plus a stray tap. The second call must not
         read a null `lb`. */
      if (!lb) return;
      /* Hold this lightbox's own element rather than reading the shared
         `lb` again 280ms from now. The old code removed whatever `lb`
         happened to point at when the timer fired: reopen the gallery
         inside that fade-out window and the timer deleted the NEW
         lightbox and nulled the reference, leaving drawer-lock on <body>
         with nothing left to take it off — the page then never scrolls
         again. */
      var el = lb;
      el.classList.remove('is-open');
      document.body.classList.remove('drawer-lock');
      /* Cleared now, not in the timeout, so the guard in openLb lets the
         gallery be reopened during the fade rather than dead-locking on a
         reference to something already on its way out. */
      lb = null;
      window.setTimeout(function () { el.remove(); }, 280);
      document.removeEventListener('keydown', onKey);
      setActive(idx, true);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    }

    lb.querySelector('.pg-lb-close').addEventListener('click', close);
    /* currentTarget, not the shared `lb` — close() nulls that, and this
       listener still has to know it was the backdrop that was clicked. */
    lb.addEventListener('click', function (e) { if (e.target === e.currentTarget) close(); });
    var prev = lb.querySelector('.pg-lb-prev');
    var next = lb.querySelector('.pg-lb-next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    document.addEventListener('keydown', onKey);

    // ---- pointer gestures: swipe / pinch / pan / double-tap ----
    var pointers = new Map();
    var startDist = 0, startScale = 1, panStart = null, lastTap = 0;

    wrap.addEventListener('pointerdown', function (e) {
      wrap.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        var p = [].slice.call(pointers.values());
        startDist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        startScale = scale;
      } else if (pointers.size === 1) {
        panStart = { x: e.clientX - tx, y: e.clientY - ty, sx: e.clientX, t: Date.now() };
      }
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        var p = [].slice.call(pointers.values());
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        scale = Math.min(4, Math.max(1, startScale * (d / startDist)));
        apply();
      } else if (pointers.size === 1 && scale > 1.02 && panStart) {
        tx = e.clientX - panStart.x;
        ty = e.clientY - panStart.y;
        apply();
      }
    });
    wrap.addEventListener('pointerup', function (e) {
      var start = panStart;
      pointers.delete(e.pointerId);
      if (pointers.size > 0) return;
      var now = Date.now();
      // double tap toggles zoom
      if (start && Math.abs(e.clientX - start.sx) < 8 && now - start.t < 260) {
        if (now - lastTap < 320) {
          if (scale > 1.02) { resetZoom(); }
          else {
            scale = 2.4;
            var r = wrap.getBoundingClientRect();
            tx = (r.width / 2 - (e.clientX - r.left)) * 1.2;
            ty = (r.height / 2 - (e.clientY - r.top)) * 1.2;
            apply();
          }
          lastTap = 0;
        } else { lastTap = now; }
      }
      // horizontal swipe when not zoomed
      if (start && scale <= 1.02) {
        var dx = e.clientX - start.sx;
        if (Math.abs(dx) > 55) show(idx + (dx < 0 ? 1 : -1));
      }
      panStart = null;
    });
    wrap.addEventListener('pointercancel', function (e) { pointers.delete(e.pointerId); });

    show(startIndex);
    window.requestAnimationFrame(function () { lb.classList.add('is-open'); });
    lb.querySelector('.pg-lb-close').focus();
  }

  g.addEventListener('click', function (e) {
    if (e.target.closest('[data-pg-open]')) { openLb(current); return; }
    var slide = e.target.closest('[data-pg-slide]');
    if (!slide) return;

    /* One tap, one lightbox.

       These were two separate ifs, and on a phone BOTH fired for the same
       tap: `is-zooming` is only ever set by the desktop hover-zoom, which
       returns early on touch, so the first condition was true — and the
       second was true because the device is mobile. Two lightboxes were
       built from one tap.

       The damage came from the rAF that adds `is-open`. It reads the
       shared `lb`, and by the time either callback ran `lb` was the
       SECOND element — so both callbacks marked that one open and the
       first never got the class. It stayed at opacity 0, full screen,
       z-index 300, with no pointer-events:none and nothing referencing
       it. Closing the visible one dropped drawer-lock, so the page looked
       normal and was covered by an invisible sheet that ate every touch.
       Hence: scrolling dead until a refresh.

       The two conditions are now one — their union, evaluated once, so
       desktop still declines while the stage is zooming and touch still
       always opens. */
    if (isMobile() || !stage.classList.contains('is-zooming')) {
      openLb(Number(slide.dataset.index));
    }
  });
})();

// ============================================================
// Product recommendations (Section Rendering API) + wishlist
// ============================================================
(function () {
  'use strict';

  // ---------- recommendations: fetch, swap, never empty ----------
  var recs = document.querySelector('[data-recs]');
  if (recs) {
    var target = recs.querySelector('[data-recs-target]');
    var fallback = recs.querySelector('[data-recs-fallback]');
    var useFallback = function () {
      if (target) target.remove();
      if (fallback) fallback.hidden = false;
    };
    fetch(recs.dataset.recsUrl, { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var grid = holder.querySelector('[data-rec-count]');
        if (grid && grid.dataset.recCount !== '0' && grid.children.length > 0) {
          target.replaceWith(grid);
          if (fallback) fallback.remove();
          if (window.vpSyncWishlist) window.vpSyncWishlist(grid);
        } else {
          useFallback();
        }
      })
      .catch(useFallback);
  }

  // ---------- wishlist (localStorage) ----------
  var KEY = 'vp_wishlist';
  function readList() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function writeList(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function syncButtons(scope) {
    var list = readList();
    (scope || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) !== -1;
      btn.classList.toggle('is-wished', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  window.vpSyncWishlist = syncButtons;
  syncButtons(document);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.handle;
    var list = readList();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    writeList(list);
    syncButtons(document);
  });
})();

// ============ Phase 2: estimated delivery date ============
(function () {
  var el = document.querySelector('[data-delivery]');
  if (!el) return;
  var min = parseInt(el.dataset.min || '7', 10);
  var max = parseInt(el.dataset.max || '10', 10);
  var skipSun = el.dataset.skipSunday === '1';
  function addDays(d, n) {
    var date = new Date(d);
    var added = 0;
    while (added < n) { date.setDate(date.getDate() + 1); if (!(skipSun && date.getDay() === 0)) added++; }
    return date;
  }
  var now = new Date();
  var lo = addDays(now, min), hi = addDays(now, max);
  var mo = { month: 'short', day: 'numeric' };
  var loS = lo.toLocaleDateString(document.documentElement.lang || 'en-IN', mo);
  var hiS = hi.toLocaleDateString(document.documentElement.lang || 'en-IN', mo);
  var out = el.querySelector('[data-delivery-range]');
  if (out) out.textContent = loS + ' – ' + hiS;
})();

// ============ Phase 3: recently viewed ============
(function () {
  var __run = function () {
  var KEY = 'vp_recently_viewed';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 20))); } catch (e) {} }
  var sec = document.querySelector('[data-recently-viewed]');
  // track current product
  var cur = sec && sec.dataset.currentHandle;
  if (!cur) { var m = document.querySelector('[data-current-handle]'); }
  var handle = sec ? sec.dataset.currentHandle : null;
  if (handle) {
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }
  if (!sec) return;
  var limit = parseInt(sec.dataset.limit || '4', 10);
  var currentHandle = sec.dataset.currentHandle;
  var handles = read().filter(function (h) { return h !== currentHandle; }).slice(0, limit);
  if (!handles.length) return;
  var host = sec.querySelector('[data-rv-items]');
  var money = function (c) { try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(c / 100); } catch (e) { return '₹' + (c / 100); } };
  Promise.all(handles.map(function (h) {
    return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  })).then(function (products) {
    var frag = document.createDocumentFragment();
    products.filter(Boolean).forEach(function (p) {
      /* Fall back to the document if the template is ever moved back
         out of the section. Looking only inside it is what silently
         broke this once already — a null here throws inside a .then(),
         which no one sees. */
      var tpl = sec.querySelector('[data-rv-card-tpl]') || document.querySelector('[data-rv-card-tpl]');
      if (!tpl) return;
      var node = tpl.content.cloneNode(true);
      node.querySelector('[data-rv-link]').href = p.url;
      var img = node.querySelector('[data-rv-img]');
      if (p.featured_image) { img.src = p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/, '_600x$1$2'); img.alt = p.title; } else { img.remove(); }
      var imgHover = node.querySelector('[data-rv-img-hover]');
      if (imgHover) {
        var secondImage = p.images && p.images.length > 1 ? p.images[1] : null;
        if (secondImage) { imgHover.src = secondImage.replace(/(\.[a-z]{3,4})(\?|$)/, '_600x$1$2'); } else { imgHover.remove(); }
      }
      node.querySelector('[data-rv-title]').textContent = p.title;
      var v = p.variants && p.variants[0];
      var rvPrice = v ? v.price : p.price;
      var rvCmp = v ? v.compare_at_price : p.compare_at_price;
      /* The same markup snippets/product-card.liquid renders, part for
         part. .product-card .product-price is a two-column grid whose
         children are placed by class, so vpPriceHtml's output — a bare
         <s>, a loose text node and a plain .price-badge — would have
         landed as three unplaced items, the text node among them an
         anonymous box the grid cannot address. vpPriceHtml is still
         what the product page's own price uses on a variant change;
         that one is not a card and is left alone. */
      var rvPriceEl = node.querySelector('[data-rv-price]');
      if (rvCmp && rvCmp > rvPrice && rvPrice > 0) {
        var rvPct = Math.round(((rvCmp - rvPrice) * 100) / rvCmp);
        rvPriceEl.innerHTML =
          '<s class="price-was">' + money(rvCmp) + '</s>' +
          '<span class="price-now">' + money(rvPrice) + '</span>' +
          (rvPct > 0 ? '<span class="price-badge price-badge--off price-badge--pct">' + rvPct + '% OFF</span>' : '');
      } else {
        rvPriceEl.innerHTML = '<span class="price-now">' + money(rvPrice) + '</span>';
      }
      frag.appendChild(node);
    });
    if (frag.childNodes.length) { host.appendChild(frag); sec.hidden = false; if (window.vpSyncWishlist) window.vpSyncWishlist(sec); }
  });
  };
  if ('requestIdleCallback' in window) requestIdleCallback(__run, { timeout: 1500 }); else setTimeout(__run, 600);
})();

// ============ Phase 4: collection filters & sorting (Search & Discovery) ============
(function () {
  var toolbar = document.querySelector('[data-collection-toolbar]');
  var form = document.querySelector('[data-filters-form]');
  var grid = document.querySelector('.collection-main');
  if (!toolbar && !form) return;

  function fetchAndSwap(url) {
    if (grid) grid.classList.add('is-loading');
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.querySelector('.collection-main');
        var newForm = doc.querySelector('[data-filters-form]');
        var newBar = doc.querySelector('[data-collection-toolbar]');
        if (newMain && grid) grid.innerHTML = newMain.innerHTML;
        if (newForm && form) form.innerHTML = newForm.innerHTML;
        if (newBar && toolbar) {
          var newSort = newBar.querySelector('[data-sort-by]');
          var curSort = toolbar.querySelector('[data-sort-by]');
          var newCount = newBar.querySelector('.collection-count');
          var curCount = toolbar.querySelector('.collection-count');
          if (newCount && curCount) curCount.textContent = newCount.textContent;
        }
        window.history.replaceState({}, '', url);
        if (grid) grid.classList.remove('is-loading');
        if (window.vpSyncWishlist) window.vpSyncWishlist(grid);
      })
      .catch(function () { if (grid) grid.classList.remove('is-loading'); window.location.href = url; });
  }

  function buildUrl() {
    var params = new URLSearchParams();
    if (form) {
      form.querySelectorAll('input').forEach(function (inp) {
        if (inp.type === 'checkbox') { if (inp.checked) params.append(inp.name, inp.value); }
        else if (inp.value) params.append(inp.name, inp.value);
      });
    }
    var sort = toolbar && toolbar.querySelector('[data-sort-by]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    var base = window.location.pathname;
    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  }

  if (form) {
    var t;
    form.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { fetchAndSwap(buildUrl()); }, 250); });
    form.addEventListener('click', function (e) {
      var clear = e.target.closest('.filter-clear');
      if (clear) { e.preventDefault(); fetchAndSwap(clear.getAttribute('href')); }
    });
  }
  if (toolbar) {
    var sortSel = toolbar.querySelector('[data-sort-by]');
    if (sortSel) sortSel.addEventListener('change', function () { fetchAndSwap(buildUrl()); });
    var ft = toolbar.querySelector('[data-filter-toggle]');
    if (ft) ft.addEventListener('click', function () {
      var open = document.body.classList.toggle('filters-open');
      ft.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
